import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../locale/useTranslation';
import DetailsScteForm from './DetailsScteForm';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import BossDialog from '../../components/BossDialog';
import FileReaderForm from '../../framework/forms/FileReaderForm';
import { EditPageHeader } from '../../components/EditPageHeader';
import { ENTITYNAME, FILEURL, SCTE_STATUS, TEMPLATENAME } from '../../framework/constant/constant';
import * as API from '../../framework/API/api';
import { toast } from 'react-toastify';
import { LocalDateTimeColumn } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import EditRoundButton from '../../framework/forms/helpercomponents/buttons/EditRoundButton';
import { TimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { utility } from '../../framework/utility/utilityProvider';
import moment from 'moment';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import MyStatusCell from '../../components/MyStatusCell';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { SCTE_Columns } from '../../framework/utility/customColumns';

const DaiScteForm = ({ ChannelId }) => {

    const lang = useTranslation();
    const [showScteForm, setShowScteForm] = useState({ show: false, item: {} });
    const [gridData, setGridData] = useState([]);
    const [filteredGridData, setFilteredGridData] = useState([]);
    const [showImportScteForm, setShowImportScteForm] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [filterData, setFilterData] = useState({
        Status: { _id: 0, Description: "All" },
        FromDate: '',
        ToDate: ''
    })
    const [statusData, setStatusData] = useState([]);

    useEffect(() => {
        loadCombo();
        loadData();
    }, [ChannelId]);

    const loadCombo = async () => {
        let statusRes = Object.keys(SCTE_STATUS).map(key => {
            return { _id: SCTE_STATUS[key], Description: key };
        })
        statusRes.unshift({ _id: 0, Description: "All" });
        setStatusData(statusRes);
    }

    const loadData = async () => {
        let res = await API.getData(ENTITYNAME.DAI_SCTES, { query: ["ChannelId", "=", ChannelId] });
        if (res.success) {
            setGridData(res.data);
            setFilteredGridData(res.data);
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const onEditData = (dataItem) => {
        setShowScteForm({ show: true, item: dataItem });
    }

    const deleteScte = async (dataItem) => {
        let res = await API.deleteScte({ ChannelId, SpliceEventId: dataItem?.SID });
        if (res.success) {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            loadData();
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const MyComandCell = (props) => {
        return (
            <td>
                <EditRoundButton onClick={() => onEditData(props.dataItem)} />
                <RoundButton title={props.dataItem?.Status == SCTE_STATUS.Pending ? "Publish" : "Unpublish"} icon={props.dataItem?.Status == SCTE_STATUS.Pending ? "arrow-up" : "arrow-down"} onClick={() => handleSCTEPublished([props.dataItem], props.dataItem.Status == SCTE_STATUS.Pending ? SCTE_STATUS.Published : SCTE_STATUS.Pending)} />
                <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteScte(props.dataItem), () => { })} />
            </td>
        )
    }

    const handleScteData = async (data) => {
        let finalData = [...gridData];
        let index = finalData.findIndex((x) => x._id == data._id);
        if (index > -1) {
            finalData[index] = data;
        } else {
            finalData.push(data);
        }
        setGridData(finalData);
        setFilteredGridData(finalData);
        setShowScteForm({ show: false, item: {} });
    }

    const handleImportData = async () => {
        if (!fileData || fileData?.length === 0) {
            toast.error(lang.no_data_found_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        const finalData = fileData.map((item) => {
            let combinedDateTime = null;

            if (item?.Date && item?.Time) {
                const datePart = moment(item.Date, ["DD/MM/YYYY", "YYYY-MM-DD"]);
                const timePart = moment(item.Time, ["HH:mm:ss", "HH:mm"]);

                if (datePart.isValid() && timePart.isValid()) {
                    combinedDateTime = moment(datePart)
                        .set({
                            hour: timePart.hour(),
                            minute: timePart.minute(),
                            second: timePart.second()
                        });
                }
            }

            return {
                ChannelId: ChannelId,
                ActionName: item?.Name,
                Duration: item?.Duration ? utility.convertStringWithFramesToMilliseconds(item?.Duration) : 0,
                Status: SCTE_STATUS.Pending,
                Time: combinedDateTime ? combinedDateTime.valueOf() : 0,
                Archive: false
            };
        });

        let res = await API.saveData(ENTITYNAME.DAI_SCTES, finalData);
        if (res.success) {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            const data = res.data?.length > 0 ? res.data.map(x => x.data) : [];
            const merged = [...gridData, ...data];
            setGridData(merged);
            setFilteredGridData(merged);
            setShowImportScteForm(false);
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };


    const handleSCTEPublished = async (data = [], Status = SCTE_STATUS.Pending) => {
        if (data?.length == 0) {
            toast.error(lang.no_data_found_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        let payload = {
            Status,
            ChannelId: ChannelId,
            ScheduleActions: data?.map(x => {
                return {
                    ActionName: x?.ActionName,
                    ScheduleActionSettings: {
                        Scte35SpliceInsertSettings: {
                            SpliceEventId: x?.SID,
                            Duration: x?.Duration
                        }
                    },
                    ScheduleActionStartSettings: {
                        FixedModeScheduleActionStartSettings: {
                            Time: x?.Time ? moment(new Date(x.Time)).format("YYYY-MM-DDTHH:mm:ss.SSSZ") : null
                        }
                    }

                }
            })
        }
        console.log(payload);
        let res = await API.sctePublishedOrUnPublished(payload);
        console.log(res);
        if (res.success) {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
            loadData();
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const StatusCell = (props) => {
        let title = utility.getKeyByValue(SCTE_STATUS, props?.dataItem?.Status);
        let tileBackColor = props?.dataItem?.Status == SCTE_STATUS.Pending ? "#E76161" : "#47A992";
        return (
            <MyStatusCell
                {...props}
                tileBackColor={tileBackColor}
                title={title}
                titleColor="#ffffff"
                margin={"20px 10px"}
                titleFontSize={"12px"}
            />
        );
    };

    const downloadTemplate = async () => {
        try {
            let filePath = FILEURL.BASEURL + 'downloadTemplate/' + TEMPLATENAME.SCTE_Template;
            window.open(filePath);
        } catch (error) {
            toast.error(`${lang.error_downloading_template_booking_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    const onFilterChange = (e) => {
        const { name, value } = e.target;
        if (name == "Status") {
            if (value._id == 0) {
                setFilteredGridData(gridData);
            } else {
                setFilteredGridData(gridData.filter(x => x.Status == value._id));
            }
        }
        if (name == "FromDate") {
            setFilteredGridData(gridData.filter(x => moment(new Date(x.Time)).format("YYYY-MM-DD") >= moment(new Date(value)).format("YYYY-MM-DD")));

        }
        if (name == "ToDate") {
            setFilteredGridData(gridData.filter(x => moment(new Date(x.Time)).format("YYYY-MM-DD") <= moment(new Date(value)).format("YYYY-MM-DD")));
        }
        setFilterData({ ...filterData, [name]: value });
    }

    const downloadExcel = async () => {
        if(gridData?.length == 0){
            toast.error(`${lang.no_record_found_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        let exportData = gridData?.length > 0 ? gridData.map(x=>{
            return {
                ...x,
                Status: utility.getKeyByValue(SCTE_STATUS, x?.Status),
                EventId: x?.SID ? parseInt(x?.SID) : ""
            }
        }) : [];
        
        let res = await API.exportGridExcel(exportData, SCTE_Columns);
        if (res.success) {
          window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
          toast.success(`${lang.successfully_download_success_message}`, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
        else {
          toast.error(res.message, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      }

    return (
        <>
            <div className="d-flex" style={{ margin: "-10px -10px 0px -10px" }}>
                <AddRoundButton style={{ marginTop: "15px", marginLeft: '10px' }} onClick={() => setShowScteForm({ show: true, item: {} })}></AddRoundButton>
                <ActionButton style={{ height: "30px", marginTop: "15px", backgroundColor: "#47A992" }} name={lang.publish_all_button_text} title={lang.publish_all_button_tooltip} onClick={() => handleSCTEPublished(gridData, SCTE_STATUS.Published)}></ActionButton>
                <div className='ml-auto d-flex'>
                    <RoundButton
                        icon="download"
                        iconColor="#ffffff"
                        btnColor="info"
                        style={{ marginTop: "13px", marginRight: '5px', width: "30px" }}
                        title={lang.export_button_tooltip}
                        onClick={downloadExcel}
                    />
                    <div style={{ marginTop: "-10px" }}>
                        <label>{lang.status_label}</label><br />
                        <DropDownList
                            style={{ backgroundColor: "white", width: "150px", height: "30px" }}
                            data={statusData}
                            name="Status"
                            textField="Description"
                            dataItemKey="_id"
                            value={filterData.Status}
                            onChange={onFilterChange}
                        />
                    </div>
                    <div style={{ marginTop: "-10px", marginLeft: "5px" }}>
                        <label>{lang.from_date_label}</label>
                        <input
                            name="FromDate"
                            type="date"
                            className="form-control form-control-sm"
                            value={filterData?.FromDate}
                            onChange={onFilterChange}
                        />
                    </div>
                    <div style={{ marginTop: "-10px", marginLeft: "5px" }}>
                        <label>{lang.to_date_label}</label>
                        <input
                            name="ToDate"
                            type="date"
                            className="form-control form-control-sm"
                            value={filterData?.ToDate}
                            onChange={onFilterChange}
                        />
                    </div>
                    <RoundButton
                        icon="upload"
                        btnColor="warning"
                        style={{ marginTop: "13px", marginRight: '5px', marginLeft: "5px", width: "30px" }}
                        title={lang.import_file_label}
                        onClick={() => setShowImportScteForm(true)}
                    />
                    <RoundButton
                        icon="download"
                        iconColor="#ffffff"
                        btnColor="success"
                        style={{ marginTop: "13px", marginRight: '5px', width: "30px" }}
                        title={lang.download_template_label}
                        onClick={downloadTemplate}
                    />
                </div>
            </div>
            <div className='mt-2 mb-2'>
                <Grid data={filteredGridData} style={{ height: '40vh' }}>
                    {/* If add new columns please add as well export column */}
                    <Column cell={MyComandCell} width={"140px"} />
                    <Column field="SID" title={lang.event_id_column} width={"90px"} />
                    <Column field="ActionName" title={lang.name_column} />
                    <Column field="Status" title={lang.status_column} width={"150px"} cell={StatusCell} />
                    <Column field="Duration" title={lang.duration_column} cell={TimeCell} />
                    <Column field="Time" title={lang.date_time_column} cell={LocalDateTimeColumn} />
                </Grid>
            </div>
            {showScteForm.show && <DetailsScteForm ChannelId={ChannelId} item={showScteForm.item} cancelEdit={() => setShowScteForm({ show: false, item: {} })} onSave={handleScteData} />}
            {showImportScteForm && <BossDialog title={lang.import_file_label} onClose={() => setShowImportScteForm(false)} width={"50%"}>
                <EditPageHeader onSubmit={handleImportData} showTitle={false} saveButtonTitle={lang.import_label} onCancel={() => setShowImportScteForm(false)} />
                <FileReaderForm setFileData={setFileData} />
            </BossDialog>}
        </>
    );
};

export default DaiScteForm;
